export const ConvertionApp = {
    ACCOUNT_PEN: 'Cuenta_Creada_Soles',
    ACCOUNT_USD: 'Cuenta_Creada_Dolares',
    DPF: 'Deposito_Exitoso',
    ENROLLEMENT: 'enrol_exitoso'
}

export const convertionAmount = {
    ACCOUNTS: 0
}

export const convertionCurrency = {
    PEN: 'PEN',
    USD: 'USD'
}